import state from './moduleCategoryState'
import actions from './moduleCategoryActions'
import getters from './moduleCategoryGetters'
import mutations from './moduleCategoryMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}

